export * from './AccessRestricted.ui';
